import React from 'react';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import { paramsQuerryChekerUrlSelect } from '../../../../DisplayComponent';


function SelectSortMoby(props) {
  const [valueSort, setSorts] = React.useState(paramsQuerryChekerUrlSelect(props));

  const onClickSort = (NewvalueSort, index) => {
    let getUrlFiltr;
    props.getFiltrSelectedAC(NewvalueSort);
    setSorts(NewvalueSort);
    if (props.getUrlFiltr == "") { getUrlFiltr = ""; } else { getUrlFiltr = "&" + props.getUrlFiltr; }
    props.params.navigate(`/${props.catalogUrl}/?${props.getUrlFiltr}&${NewvalueSort}&countItems=${props.pageSize}&page=${props.currentPage}`)
    props.getCatalogItems(props.pageSize, props.currentPage, `&${getUrlFiltr}&${NewvalueSort}`);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      <List component="div" role="group" >

        {
          props.filterSort
            .map((u, k) => {
              return (
                <ListItem
                  key={k}
                  divider
                  onClick={() => onClickSort(u.value, k)}
                >
                  {valueSort == u.value
                    ?
                    <ListItemText primary={u.label} sx={{ color: '#ff6000' }} />
                    :
                    <ListItemText primary={u.label} />
                  }
                </ListItem>
              )
            })
        }

      </List>
    </Box>
  );
}

export default SelectSortMoby;